import './css/main.scss';

// these will add the data to the build.js
// import clientData from './json/clientData.json';
// import sampleData from  './assets/sampleData';
// console.log("~~~~~~~~~~~~~~~~> sampleData: ", sampleData);

import Vue from 'vue';
import VueRouter from 'vue-router';
import {routes} from './routes.js';
import App from './App.vue';
// import axios from 'axios';


// console.log(window.location.href);
// console.log(window.location.hostname);
// if (window.location.hostname === "localhost" || window.location.href === "https://wp-range.workalicious.dvlp") {
//   axios.defaults.baseURL = 'https://wp-range.workalicious.dvlp/';
// } else {
//   axios.defaults.baseURL = 'https://wp-range.workalicious.work/';
// }



// import vueLogo from './assets/logo.png';
// Add the image to our existing div.
// let logoSvg = new Image();
// logoSvg.src = vueLogo;

Vue.use(VueRouter);

const router = new VueRouter({
  routes,         // same as routes: routes.js
  mode: 'history', // tell the router the server is configured to always return index.html and remove the #
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
});

new Vue({
  el: '#app',
  router,         // same as router: router
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js